<template>
  <q-card
    @click.native="$router.push({ name: 'activityDetail', params: { id: activity.id } })"
    class="q-mb-md cursor-pointer"
  >
    <q-card-title class="bg-secondary">
      {{ activity.attributes.subject }}
      <div slot="subtitle" class="row justify-between">
        <span>{{activity.attributes.start_time }} - {{ activity.attributes.end_time}}</span>
        <span>{{ activityStatus }}</span>
      </div>
    </q-card-title>
    <q-card-separator />
    <q-list>
      <q-item>
        <q-item-side icon="business"/>
        <q-item-main>
          {{ accountName }}
        </q-item-main>
      </q-item>
      <q-item>
        <q-item-side icon="person"/>
        <q-item-main>
          {{ contactName }}
        </q-item-main>
      </q-item>
    </q-list>
  </q-card>
</template>

<script>
export default {
  props: ['activity', 'schema'],
  data () {
    return {
      activity_type: this.activity.attributes.activity_type
    }
  },
  computed: {
    accountName () {
      const account = this.relatedObj('accounts')
      return account ? account.attributes.name : ''
    },
    contactName () {
      const contact = this.relatedObj('contacts')
      if (contact) {
        return contact.attributes.last_name
      } else {
        return ''
      }
    },
    activityStatus () {
      const key = 'event_status'
      const picklist = this.schema[key] && this.schema[key].picklist_id
      const values = this.$store.getters.picklistValues(picklist, this.$i18n.locale)
      const value = values.find(val => val.value === this.activity.attributes[key]) || {}
      return value.label
    }
  },
  methods: {
    relatedObj (type) {
      const rel = this.activity.relationships[type].data[0]
      if (!rel) return
      const id = rel.id
      const obj = this.$store.state.activities.activities.included.find(item =>
        item.type === type && item.id === id)
      return obj
    }
  }
}
</script>
